// @flow

export default {
  IN_STOCK: 'product__status--in-stock',
  OUT_OF_STOCK_SHORT_DELIVERY: 'product__status--out-of-stock--short-delivery',
  OUT_OF_STOCK_LONG_DELIVERY: 'product__status--out-of-stock--long-delivery',
  OUT_OF_STOCK_UNKNOWN: 'product__status--out-of-stock--unknown',
  OUT_OF_STOCK_CLASS: 'text-black',
  IN_STOCK_CLASS: 'text-tertiary'
};
